import {Component} from '@angular/core';
import {UserAccessService} from '~/app/core/services/user-access.services';
import {UserAdmin} from '~/app/core/reports/models/user-admin';
import {UserService} from "~/app/core/services/user.service";
import {UserAdminReport} from "~/app/core/reports/models/user-admin-report";
import {ToastrService} from "ngx-toastr";
import {Report} from "~/app/core/reports/models/report";
import { LoadingIndicatorHelper } from '~/app/core/services/loading-indicator-helper';

@Component({
  selector: 'app-report-access',
  templateUrl: './report-access.component.html',
  styleUrls: ['./report-access.component.scss']
})

export class ReportAccessComponent {
  username: string;
  firstLabelName = 'User';
  secondLabelName = 'Report Category';

  currentAssigned: UserAdmin[];
  currentAvailable: UserAdmin[];
  userData: UserAdmin[];
  userIds: string[];
  selectedHoId: string;
  reportData: Report[];
  reportCategories: string[];
  userReportData: UserAdminReport[];
  assignedList: UserAdminReport[] = [];
  availableList: UserAdminReport[] = [];
  finalUpdateList: UserAdminReport[] = [];
  assignedReports: UserAdminReport[];
  availableReports: UserAdminReport[];
  private _tempUsers: string[];
  private _tempCategories: string[];
  private _tempHoId: number;
  private _userSelectedValue: string;
  private _categorySelectedValue: string;


  constructor(public loadingIndicator: LoadingIndicatorHelper,
              public userAccessService: UserAccessService,
              private _userService: UserService,
              public toastService: ToastrService) {
  }

  async ngOnInit(): Promise<void> {
    this.username = this._userService.getUserName().toUpperCase();
    this.selectedHoId = this.userAccessService.getSelectedHoId();

    this.userData = await this.userAccessService.getUsers(this.username);
    this.userIds = await this.getUserIds(this.userData);

    this.reportData = await this.userAccessService.getAllReportCategories();
    this.reportCategories = await this.getReportCategories(this.reportData);
    this.loadingIndicator.hide();
  }

  getUserIds(usersList: UserAdmin[]): string[] {
    this._tempUsers = [];
    this._tempHoId = Number(this.selectedHoId);

    usersList.forEach((item) => {
      if (item.hoId === this._tempHoId)
        this._tempUsers.push(item.userId);
    })
    return this._tempUsers;
  }

  getReportCategories(reportDataList: Report[]): string[] {
    this._tempCategories = [];
    reportDataList.forEach((item, index) => {
      if(index === reportDataList.findIndex(i => i.category === item.category))
        this._tempCategories.push(item.category);
    })
    return this._tempCategories;
  }

  async userSelectorValue(results): Promise<void>{
    this.availableList = [];
    this.assignedList = [];
    this._userSelectedValue = results;

    if(this._userSelectedValue !== 'USER' && (this._categorySelectedValue !== 'Report Category' && this._categorySelectedValue !== undefined)){
      this.getUserReportsList(this.selectedHoId, this._userSelectedValue, this._categorySelectedValue).then(r => {
    });
    }
  }

  async categorySelectorValue(results): Promise<void>{
    this.availableList = [];
    this.assignedList = [];
    this._categorySelectedValue = results;

    if(this._categorySelectedValue !== 'Report Category' && (this._userSelectedValue !== 'User' && this._userSelectedValue !== undefined)){
      await this.getUserReportsList(this.selectedHoId, this._userSelectedValue, this._categorySelectedValue).then(r => {
      });
    }
  }

  // After user makes selections load report lists
  async getUserReportsList(hoId: string, username: string, category: string): Promise<void> {
    if (category !== 'User' && this._userSelectedValue !== 'Report Category'){
      this.userReportData = await this.userAccessService.getAssignedReports(this.selectedHoId, username);
    }
    await this.getCategorySelectedAssignedReports(this.userReportData, category);
  }

  async getCategorySelectedAssignedReports(userReportList: UserAdminReport[], selected: string): Promise<void> {
    userReportList.forEach((item) => {
      if(item.category === selected){
        if(item.assigned) {
          this.assignedList.push(item);
        } else {
          this.availableList.push(item);
        }
      }
    });
  }

  async pickListFormResults(e): Promise<void> {
    this.assignedList.forEach((report) => {
      if(!report.assigned) {
        report.assigned = true;
        this.finalUpdateList.push(report);
      }
    });

    this.availableList.forEach((report) => {
      if(report.assigned) {
        report.assigned = false;
        this.finalUpdateList.push(report);
      }
    });

    // update API
    await this.userAccessService.updateReports(Number(this.selectedHoId), this._userSelectedValue, this.username, this.finalUpdateList)
      .then(response => {
        if(response === 0) {
          this._userService.showNotification('User updated Successfully',2000);
        }
      }).catch((error) => {
        this._userService.showError('Problem updating user reports', 2000);
    });

  }

}
